import { DashboardConstants } from "src/redux/actions/constant";

const {
    CO_SIGNATURE_REVIEW_REQUEST,
    CO_SIGNATURE_REVIEW_SUCCESS,
    CO_SIGNATURE_REVIEW_FAILURE,
    CO_SIGNATURE_REVIEW_RESET,
    CO_SIGNATURE_REVIEW_LOADING,
} = DashboardConstants;

const intitialstate: object = {
  response: null,
  isCoSignature: false,
  loading: false,
  requestType: null,
};

export const coSignatureReviewReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case CO_SIGNATURE_REVIEW_SUCCESS: {
      return {
        ...state,
        isCoSignature: true,
        response: action.payload?.data,
        loading: false,
        requestType: action?.requestType,
      };
    }

    case CO_SIGNATURE_REVIEW_FAILURE:
      return {
        ...state,
        isCoSignature: false,
        errorMessage: action.payload,
        response: null,
        loading: false,
      };

    case CO_SIGNATURE_REVIEW_RESET:
      return intitialstate;

    case CO_SIGNATURE_REVIEW_LOADING:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
